var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "steps__row",
    class: [{
      'steps__row_stretch-tabs': _vm.stretchTabsByWidth
    }]
  }, _vm._l(_vm.list, function (el, index) {
    return _c('div', {
      key: el.value,
      staticClass: "steps__step-tab",
      class: {
        'steps__step-tab_active': index === _vm.current,
        'steps__step-tab_completed': index < _vm.current
      },
      attrs: {
        "data-e2e": "step-tab"
      },
      on: {
        "click": function ($event) {
          return _vm.goTo(index);
        }
      }
    }, [_c('div', {
      staticClass: "steps__step-tab-round"
    }, [_vm._v("\n        " + _vm._s(index + 1) + "\n      ")]), _vm._v(" "), _c('span', {
      staticClass: "steps__step-tab-text"
    }, [_vm._v(_vm._s(el.name))])]);
  }), 0), _vm._v(" "), _vm._t("top"), _vm._v(" "), _vm._l(_vm.list, function (el, index) {
    return _c('div', {
      key: el.value,
      staticClass: "steps__content",
      class: {
        steps__content_active: index === _vm.current
      }
    }, [_c('keep-alive', [index === _vm.current ? _vm._t(el.value, null, {
      "next": _vm.next,
      "prev": _vm.prev
    }) : _vm._e()], 2)], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }